import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { isIpeWorkbenchPath } from '@/config/ipeRoutes';
import { buildWorkbenchNavUrl, navigateWorkbenchWithState } from '@/pages/ipe/workbench/constants/workbenchNavConfig';
import { useIpeRechargeCart } from '@/pages/ipe/workbench/hooks/useIpeRechargeCart';

function CartBadge({ count }) {
  if (!count || count <= 0) return null;
  const label = count > 99 ? '99+' : String(count);
  return (
    <span className="ipe-workbench-cart__badge" aria-hidden="true">
      {label}
    </span>
  );
}

export default function IpeRechargeCartButton() {
  const { count } = useIpeRechargeCart();
  const location = useLocation();
  const navigate = useNavigate();

  const openCart = (event) => {
    event?.stopPropagation?.();
    const tab = 'cart';
    try {
      sessionStorage.setItem('ipe:order-center-initial-tab', tab);
    } catch {
      /* ignore */
    }
    window.dispatchEvent(new CustomEvent('ipe:open-order-center', { detail: { tab } }));
    if (isIpeWorkbenchPath(location.pathname)) {
      navigateWorkbenchWithState(navigate, 'orderCenter');
      return;
    }
    navigate(buildWorkbenchNavUrl('orderCenter'));
  };

  return (
    <button
      type="button"
      className="ipe-workbench-cart__btn"
      aria-label={count > 0 ? `购物车，${count} 件商品` : '购物车'}
      title="购物车"
      onClick={openCart}
    >
      <ShoppingCart size={18} strokeWidth={1.9} aria-hidden="true" />
      <CartBadge count={count} />
    </button>
  );
}
